// extracted by mini-css-extract-plugin
export default {"videoContainer":"VideoStatic_videoContainer__o5FHX","videoPlayer":"VideoStatic_videoPlayer__Qwi3j"};